import React from 'react';
import { Hourglass } from 'lucide-react';
import { TabWip } from './Reports';

// Standalone page for uninvoiced value / work in progress (sidebar under Reports).
export default function Uninvoiced() {
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-3">
        <Hourglass size={22} className="text-orange-500" />
        <div>
          <h1 className="text-xl font-bold text-gray-800">Uninvoiced Value</h1>
          <p className="text-xs text-gray-400">Delivered, priced parcels not yet billed — revenue in the pipeline</p>
        </div>
      </div>
      <TabWip />
    </div>
  );
}
